module.exports = __webpack_public_path__ + "img/dimension.afafb03f.svg";